import { useState, useEffect } from "react";
import { registerLoader } from "../../Services/Loader/loaderService";
import { useLocalization } from "../../../context/LocalizationContext";

const Loader = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t: localization } = useLocalization();

  useEffect(() => {
    registerLoader(setIsVisible);
  }, []);
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: 99999999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="spinner-border text-white"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">{localization("loading")}</span>
      </div>
    </div>
  );
};

export default Loader;